import React from 'react';
import { useDispatch } from 'react-redux';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import * as adminInfoActions from 'redux/ducks/adminInfo/adminInfoDucks';

export const FinishedButton = ({ label, icon, config }) => {
  const dispatch = useDispatch();

  const handleOnClick = cfg => {
    dispatch(adminInfoActions.updateFinishPortalConfig({ ptConfYn: 'Y' }));
    const objString = JSON.stringify({ serviceManagementMenuCode: cfg });
    window.localStorage.setItem('brityWorksAdminInitialMenu', objString);
    window.open(`${window.location.origin}/adminportalapp/main`);
  };

  return (
    <>
      <div className="list">
        <div
          className="wrapper"
          onClick={() => {
            handleOnClick(config);
          }}
        >
          <div className="tit">
            <div className={`img ${icon}`} />
            <h1 className="main-text">
              <Trans i18nKey={label} />
            </h1>
          </div>
          <i className="ic-right sm" />
        </div>
      </div>
    </>
  );
};
FinishedButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  config: PropTypes.string.isRequired,
};
FinishedButton.defaultProps = {};
export default FinishedButton;
